/* eslint-disable no-restricted-properties */
type Environment = 'test' | 'default';
export const setEnvironment = (env: Environment) => {
  localStorage.setItem('environment', env);
};

export const getEnvironment = (): Environment => {
  const env = localStorage.getItem('environment');
  if (env === 'test') return 'test';
  return 'default';
};

export const environment = {
  REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  REACT_APP_NOTABENE_NODE_URL:
    getEnvironment() === 'test'
      ? process.env.REACT_APP_NOTABENE_NODE_URL_TEST
      : process.env.REACT_APP_NOTABENE_NODE_URL,
  REACT_APP_CONTENTFUL_SPACE_ID:
    getEnvironment() === 'test'
      ? process.env.REACT_APP_CONTENTFUL_SPACE_ID_TEST
      : process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  REACT_APP_CONTENTFUL_ENVIRONMENT_ID:
    getEnvironment() === 'test'
      ? process.env.REACT_APP_CONTENTFUL_ENVIRONMENT_ID_TEST
      : process.env.REACT_APP_CONTENTFUL_ENVIRONMENT_ID,
  REACT_APP_CONTENTFUL_ACCESS_TOKEN:
    getEnvironment() === 'test'
      ? process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN_TEST
      : process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
  REACT_APP_BASE_URL:
    getEnvironment() === 'test'
      ? process.env.REACT_APP_BASE_URL_TEST
      : process.env.REACT_APP_BASE_URL,
  REACT_APP_HOME_URL:
    getEnvironment() === 'test'
      ? process.env.REACT_APP_HOME_URL_TEST
      : process.env.REACT_APP_HOME_URL,
  REACT_APP_ZENDESK_URL:
    getEnvironment() === 'test'
      ? process.env.REACT_APP_ZENDESK_URL_TEST
      : process.env.REACT_APP_ZENDESK_URL,

  REACT_APP_MIXPANEL_TOKEN:
    getEnvironment() === 'test'
      ? process.env.REACT_APP_MIXPANEL_TOKEN_TEST
      : process.env.REACT_APP_MIXPANEL_TOKEN,
  REACT_APP_CLARITY_ID:
    getEnvironment() === 'test'
      ? process.env.REACT_APP_CLARITY_ID_TEST
      : process.env.REACT_APP_CLARITY_ID,
  READONLY: process.env.REACT_APP_READONLY === 'true',
};
